import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-progress-circle',
  templateUrl: './progress-circle.component.html',
  styleUrls: ['./progress-circle.component.scss'],
})
export class ProgressCircleComponent implements OnInit {
  @Input() percentage: number = 0;
  @Input() label: string = '';
  @Input() color: string = '#29659f';
  @Input() size: number = 100;
  @Input() strokeWidth: number = 8;

  radius: number = 0;
  circumference: number = 0;
  offset: number = 0;
  center: number = 0;

  ngOnInit() {
    this.radius = (this.size - this.strokeWidth) / 2;
    this.circumference = 2 * Math.PI * this.radius;
    this.offset = this.circumference - (this.percentage / 100) * this.circumference;
    this.center = this.size / 2;
  }
}
